module.exports = __webpack_public_path__ + "static/media/2024.10.22 Amended and Restated Initial Order.a2e34d42.pdf";